@if (!showSkeletonLoader) {
  <div class="column-21 w-col">
    <div class="mygoal_div">
      @if (config?.data?.link) {
        <a href="{{config.data.link}}" class="viewmorelink viewmorelinksmob">VIEW MORE</a>
      }
      <div class="mygoal_heading">
        @if (config?.data?.heading) {
          <h6 class="heading-15">{{config?.data?.heading}}</h6>
        }
        <div class="sync_div">
          <a href="#" class="link-block-5 w-inline-block">
            <div class="sync_icon">Sync<br>‍</div><img src="images/start.png" loading="lazy" alt="" class="sync_img">
          </a>
        </div>
      </div>
      <div class="mygoal_cover w-row">
        <div class="left_mygoals w-col w-col-5">
          @if (config?.data?.imgUrl) {
            <img  [src]="config.data.imgUrl" loading="lazy" alt="" class="image-707">
          }
          @if (config?.data?.btn_text) {
            <div style="cursor:pointer" (click)="handleLinkClick()"  class="viewmorelink">{{config.data.btn_text}}</div>
          }
        </div>
        <div class="right_mygoals w-col w-col-7">
          <div class="mygoal_firstdiv"><img src="assets/images/wellness-app/images/heart.png" loading="lazy" alt="" class="mygoal_icon">
            <div class="mygoal_text">
              <p class="tagline">Pulses</p>
              <div class="text-block-555"><strong class="bold-text-2">--</strong> Bpm</div>
            </div>
          </div>
          <div class="mygoal_firstdiv"><img src="assets/images/wellness-app/images/steps.png" loading="lazy" alt="" class="mygoal_icon">
            <div class="mygoal_text">
              <p class="tagline">Steps</p>
              <div class="text-block-555"><strong class="bold-text-4">--</strong></div>
            </div>
          </div>
          <div class="mygoal_firstdiv"><img src="assets/images/wellness-app/images/calorie.png" loading="lazy" alt="" class="mygoal_icon">
            <div class="mygoal_text">
              <p class="tagline">Calories</p>
              <div class="text-block-555"><strong>--</strong><strong class="bold-text-5"> </strong>Kcal</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (showSkeletonLoader) {
  <div class="mygoal_div">
    <app-skeleton-loader  [height]="height"></app-skeleton-loader>
  </div>
}